import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "next-position",
  "use": "next-position-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"next-position\"><path d=\"m10.77 5.5 5.41 6.52-5.41 6.52-1.54-1.28 4.35-5.24-4.35-5.24zM21 9a3 3 0 1 1 0 6 3 3 0 0 1 0-6zM2 11.02v2H0v-2zm8 0v2H8v-2zm-4 0v2H4v-2z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol